/*
 * SCP Saved / Wishlist page behaviour.
 *
 * The shared product-card JS (scp-product-card-assets) owns the localStorage
 * key `scp-saved` (an array of Shopify product IDs) and the heart toggle on
 * every card. This script drives the /saved (page.saved) template only:
 *
 *   - reads `scp-saved`
 *   - clones the matching hidden <template data-tpl-id="<id>"> cards (emitted
 *     server-side, one per shop product) into the visible saved grid
 *   - keeps the grid + count + empty state + recommendations in sync when a
 *     heart is toggled (anywhere) or items are cleared
 *   - sorts (recently saved / price low-high / high-low)
 *   - "Clear all" with a confirm
 *
 * Stays in sync with the card JS via the shared localStorage key plus a
 * `storage` listener and a click delegate on the page's own hearts.
 */
(function () {
  var SAVED_KEY = 'scp-saved';

  function getSaved() {
    try { return JSON.parse(localStorage.getItem(SAVED_KEY) || '[]'); } catch (e) { return []; }
  }
  function setSaved(list) {
    try { localStorage.setItem(SAVED_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function init() {
    var root = document.querySelector('.scp-saved');
    if (!root) return;

    var templatesWrap = root.querySelector('[data-scp-card-templates]');
    var grid = root.querySelector('[data-scp-saved-grid]');
    var sortbar = root.querySelector('[data-scp-sortbar]');
    var countEl = root.querySelector('[data-scp-count]');
    var sortSelect = root.querySelector('[data-scp-sort]');
    var emptyEl = root.querySelector('[data-scp-empty]');
    var clearBtn = root.querySelector('[data-scp-clear-all]');
    var recsEl = root.querySelector('[data-scp-recs]');
    var recsTitle = root.querySelector('[data-scp-recs-title]');
    if (!grid || !templatesWrap) return;

    // id -> { html, price } from the server-rendered templates
    var catalog = {};
    templatesWrap.querySelectorAll('template[data-tpl-id]').forEach(function (tpl) {
      var id = tpl.getAttribute('data-tpl-id');
      var price = parseInt(tpl.getAttribute('data-price'), 10);
      catalog[id] = { html: tpl.innerHTML, price: isNaN(price) ? 0 : price };
    });

    function applySort(ids) {
      var mode = sortSelect ? sortSelect.value : 'recent';
      if (mode === 'recent') return ids; // insertion order from localStorage
      var sorted = ids.slice();
      sorted.sort(function (a, b) {
        var pa = catalog[a] ? catalog[a].price : 0;
        var pb = catalog[b] ? catalog[b].price : 0;
        return mode === 'price-low' ? pa - pb : pb - pa;
      });
      return sorted;
    }

    function render() {
      var saved = getSaved().filter(function (id) { return catalog[id]; });
      var count = saved.length;

      // toggle high-level states
      var isEmpty = count === 0;
      var isSmall = count < 3;

      if (emptyEl) emptyEl.hidden = !isEmpty;
      if (sortbar) sortbar.hidden = isEmpty;
      if (clearBtn) clearBtn.hidden = isEmpty;
      grid.hidden = isEmpty;

      if (countEl) countEl.textContent = count + (count === 1 ? ' item saved' : ' items saved');

      // build the saved grid from templates in sort order
      grid.innerHTML = '';
      if (!isEmpty) {
        applySort(saved).forEach(function (id) {
          var tmp = document.createElement('div');
          tmp.innerHTML = catalog[id].html;
          var card = tmp.firstElementChild;
          while (card && card.nodeType !== 1) card = card.nextElementSibling;
          if (card) grid.appendChild(card);
        });
      }

      // recommendations: shown when empty or small list (mirrors Saved.tsx)
      if (recsEl) {
        var showRecs = isEmpty || isSmall;
        recsEl.hidden = !showRecs;
        if (showRecs) {
          if (recsTitle) recsTitle.textContent = isEmpty ? 'Popular products' : 'You might also like';
          recsEl.classList.toggle('scp-saved__recs--empty', isEmpty);
          // hide any recommendation card already in the saved list
          recsEl.querySelectorAll('[data-rec-id]').forEach(function (item) {
            item.style.display = saved.indexOf(item.getAttribute('data-rec-id')) !== -1 ? 'none' : '';
          });
        }
      }

      // re-sync hearts on freshly cloned cards (and recs)
      document.dispatchEvent(new CustomEvent('scp:cards:rendered'));
    }

    // re-render whenever a heart is toggled on THIS page (card JS already
    // updated localStorage by the time this delegate fires after it)
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-scp-save]')) {
        // let the card JS write localStorage first
        setTimeout(render, 0);
      }
    });

    // cross-tab + same-tab safety: re-render when storage changes
    window.addEventListener('storage', function (e) {
      if (e.key === SAVED_KEY) render();
    });

    if (sortSelect) sortSelect.addEventListener('change', render);

    if (clearBtn) clearBtn.addEventListener('click', function () {
      if (getSaved().length === 0) return;
      if (window.confirm('Clear all saved items? This cannot be undone.')) {
        setSaved([]);
        render();
      }
    });

    render();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
